import { fromJS } from "immutable";
import {
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UPDATE_CONFIG,
  UPDATE_AUTO_REFRESH_CONFIG,
} from "./constants";
import appConfig from "./appConfig";

// Load config from localStorage or use default
const loadConfig = () => {
  try {
    const savedConfig = localStorage.getItem("appConfig");
    if (savedConfig) {
      const parsed = JSON.parse(savedConfig);
      // Deep merge to ensure all nested properties exist
      return {
        ...appConfig,
        ...parsed,
        orderChecker: {
          ...appConfig.orderChecker,
          ...(parsed.orderChecker || {}),
          autoRefresh: {
            ...appConfig.orderChecker.autoRefresh,
            ...(parsed.orderChecker?.autoRefresh || {}),
          },
        },
      };
    }
  } catch (error) {
    console.error("Failed to load config from localStorage:", error);
  }
  return appConfig;
};

// Save config to localStorage
const saveConfig = (config) => {
  try {
    localStorage.setItem("appConfig", JSON.stringify(config));
  } catch (error) {
    console.error("Failed to save config to localStorage:", error);
  }
};

const initialConfig = loadConfig();

export const initialState = fromJS({
  config: initialConfig,
});

function logoutReducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return state.set("logout", null).set("loading", null).set("error", null);
    case LOGOUT_SUCCESS:
      return state.set("logout", null).set("loading", false).set("error", null);
    case LOGOUT_ERROR:
      return state
        .set("logout", null)
        .set("loading", false)
        .set("error", action.error.message);
    case UPDATE_CONFIG: {
      const currentConfig = state.get("config") || {};
      const newConfig = { ...currentConfig, ...action.config };
      saveConfig(newConfig);
      return state.set("config", newConfig);
    }
    case UPDATE_AUTO_REFRESH_CONFIG: {
      const currentConfig = state.get("config") || {};
      const newConfig = {
        ...currentConfig,
        orderChecker: {
          ...(currentConfig.orderChecker || {}),
          autoRefresh: {
            ...(currentConfig.orderChecker?.autoRefresh || {
              enabled: true,
              interval: 30,
            }),
            ...action.autoRefreshConfig,
          },
        },
      };
      saveConfig(newConfig);
      return state.set("config", newConfig);
    }
    default:
      return state;
  }
}

export default logoutReducer;
